import { PropsWithChildren, useRef } from "react";

import { css } from "@emotion/react";
import { Box, useTheme } from "@mui/material";

import { ThemeMode, useLayoutContext } from "components/Layout/context";
import { MoodysThemeProviderWhitney } from "components/MoodysThemeProviderWhitney";

import { useHeaderVariant } from "../../../../hooks/useHeaderVariant";
import { MenuContextProvider } from "../../../Menu";
import { HeaderWithContext } from "../HeaderWithContext";

import { headerLayoutStyles as styles } from "./../../Header.styles";

export const HeaderWithTheme = ({ children }: PropsWithChildren) => {
  const { headerVariant, themeMode } = useLayoutContext();
  const disableElevation = themeMode !== ThemeMode.LIGHT;
  const theme = useTheme();
  const pageHeaderRef = useRef<HTMLElement>();
  const { pageHeader, pageStickyHeader } = useLayoutContext();
  const { headerRef, stickyPageHeaderRef } = useHeaderVariant(
    {
      headerVariant,
      disableElevation,
    },
    [pageStickyHeader, pageHeader, headerVariant, disableElevation]
  );

  return (
    <>
      <Box id="web-core-presentation" />
      <Box
        ref={headerRef}
        css={[
          styles.header,
          css({
            colorScheme: themeMode,
          }),
        ]}
      >
        <MenuContextProvider>
          <HeaderWithContext>{children}</HeaderWithContext>
        </MenuContextProvider>
      </Box>
      <MoodysThemeProviderWhitney>
        {pageHeader && (
          <Box
            ref={pageHeaderRef}
            css={styles.pageHeaderContainer(theme, -2)}
            id="web-core-page-header"
          >
            {pageHeader}
          </Box>
        )}
        {pageStickyHeader && (
          <Box
            ref={stickyPageHeaderRef}
            id="web-core-page-sticky-header"
            data-testid="page-sticky-header"
            css={[
              styles.header,
              styles.pageHeaderContainer(theme, -1),
              styles.pageStickyHeader,
            ]}
          >
            <Box>{pageStickyHeader}</Box>
          </Box>
        )}
      </MoodysThemeProviderWhitney>
    </>
  );
};
